//Admin Routes
import AdminDashboard from "../admin/pages/dashboard/dashboard";
import MyProfile from "../admin/pages/myprofile/MyProfile";
import CompanyProfile from "../admin/pages/companyprofile/CompanyProfile";
import Subscribe from "../admin/pages/subscribe/subscribe";
import SubscribeSuccess from "../admin/pages/subscribe-success/subscribe-success";
import UserList from "../admin/pages/user/list";
import UserRoleList from "../admin/pages/userrole/list";
import UserPermissionList from "../admin/pages/userpermission/list";
import CompanyList from "../admin/pages/company/list";
import DriverList from "../admin/pages/driver/list";
import CustomerList from "../admin/pages/customer/list";
import ProductList from "../admin/pages/product/list";
import DeliveryProductList from "../admin/pages/delivery-product/list";
import AddBooking from "../admin/pages/booking/add-booking/AddBooking";
import AddDeliveryBooking from "../admin/pages/booking/add-delivery-booking/AddBooking";
import BookingList from "../admin/pages/booking/booking-list/list";
import BookingEnquery from "../admin/pages/booking/booking-list/enquiryList";
import AssignDriver from "../admin/pages/booking/assign-driver/list";
import DriverJobs from "../admin/pages/booking/driver-jobs/list";
import PickedBooking from "../admin/pages/booking/pickedupitems/list";
import ContainerList from "../admin/pages/shipping/containerList";
import ShippingList from "../admin/pages/shipping/list";
import AddShipping from "../admin/pages/shipping/add";
import DeliveryReceiveShipping from "../admin/pages/delivery/receiveShipping";
//import DeliveryAssignTodriver from "../admin/pages/delivery/assignToDriver";
import DeliveryAssignTodriver from "../admin/pages/delivery/assign-driver/list";
import DriverJobDelivery from "../admin/pages/delivery/driverJobDelivery";
import SubscriptionList from "../admin/pages/subscription/list"
import MembershipList from "../admin/pages/membership-manager/list";

//Customer Routes
import MyBooking from "../customer/pages/mybooking/mybooking";
import CustomerBooking from "../customer/pages/add-bookings/add";
import CustomerMyProfile from "../customer/pages/myprofile/myprofile";
import UpdateProfile from "../customer/pages/updateprofile/updateprofile";
import ChangePassword from "../customer/pages/changepassword/changepassword";
import TrackBookingCustomer from "../customer/pages/track-booking/track-booking";
import ReferralHistory from "../customer/pages/referralhistories/referralhistories";

//Fontend Routes
import Home from "../fontend/pages/home/Home";
import ContactUs from "../fontend/pages/contactus/Contactus";
import Terms from "../fontend/pages/terms/terms";
import Login from "../fontend/pages/login/Login";
import Signup from "../fontend/pages/signup/Signup";
import CustomerSignup from "../fontend/pages/customer-signup/CustomerSignup";
import CustomerSignup2 from "../fontend/pages/customer-signup/CustomerSignup2";
import ForgotPassword from "../fontend/pages/forgotpassword/forgotpassword";
import ForgotPasswordcodeCheck from "../fontend/pages/forgotpasswordcodecheck/ForgotPasswordCodeCheck";
import ForgotPasswordChange from "../fontend/pages/forgotchangepassword/ForgotChangePassword";
import TrackBooking from "../fontend/pages/track-booking/track-booking";

//Driver Routes
import TodayRequestList from "../driver/pages/TodayRequestList";
import DriverAddressDetails from "../driver/pages/DriverAddressDetails";
import DriverAddressEdit from "../driver/pages/DriverAddressEdit";
import DriverItemDetails from "../driver/pages/DriverItemDetails";
import DriverItemEdit from "../driver/pages/DriverItemEdit";
import DriverPaymentDetails from "../driver/pages//DriverPaymentDetails";

const HomeRoutes = {
  path: "/",
  component: Home,
};

const ContactUsRoutes = {
  path: "/contact-us",
  component: ContactUs,
};

const TermsRoutes = {
  path: "/terms",
  component: Terms,
};

const LoginRoutes = {
  path: "/sign-in",
  component: Login,
};
const SignupRoutes = {
  path: "/sign-up",
  component: Signup,
};
const CustomerSignupRoutes = {
  path: "/customer-sign-up/:str",
  component: CustomerSignup,
};
const CustomerSignup2Routes = {
  path: "/customer-sign-up/:ctoken/:str",
  component: CustomerSignup2,
};
const ForgotpasswordRoutes = {
  path: "/forgot-password",
  component: ForgotPassword,
};
const ForgotpassworCodeCheckdRoutes = {
  path: "/forgot-password-code-check",
  component: ForgotPasswordcodeCheck,
};
const ForgotpasswordChangeRoutes = {
  path: "/forgot-password-change",
  component: ForgotPasswordChange,
};
const TrackBookingRoutes = {
  path: "/track-booking",
  component: TrackBooking,
};
export const AdminRoutes = {
  routeList: [
    {
      path: "/:companySlug/dashboard",
      component: AdminDashboard,
      menuName: "dashboard",
      permission: "dashboard:view",
    },
    {
      path: "/:companySlug/my-profile",
      component: MyProfile,
      menuName: "myprofile",
      permission: "all:read",
    },
    {
      path: "/:companySlug/company-profile",
      component: CompanyProfile,
      menuName: "companyprofile",
      permission: "all:read",
    },
    {
      path: "/:companySlug/subscribe",
      component: Subscribe,
      menuName: "subscribe",
      permission: "all:read",
    },
    {
      path: "/:companySlug/subscribe-success",
      component: SubscribeSuccess,
      menuName: "subscribe-success",
      permission: "all:read",
    },
    {
      path: "/:companySlug/customer/list",
      component: CustomerList,
      menuName: "customer",
      permission: "customers:list",
    },
    {
      path: "/:companySlug/user/list",
      component: UserList,
      menuName: "settings",
      permission: "settings:user-list",
    },
    {
      path: "/:companySlug/user-role/list",
      component: UserRoleList,
      menuName: "settings",
      permission: "settings:user-role-list",
    },
    {
      path: "/:companySlug/user-permissions",
      component: UserPermissionList,
      menuName: "settings",
      permission: "settings:user-permission",
    },
    {
      path: "/:companySlug/driver/list",
      component: DriverList,
      menuName: "driver",
      permission: "drivers:list",
    },
    {
      path: "/:companySlug/product/list",
      component: ProductList,
      menuName: "items",
      permission: "items:list",
    },
    {
      path: "/:companySlug/delivery-product/list",
      component: DeliveryProductList,
      menuName: "items",
      permission: "items:list",
    },
    {
      path: "/:companySlug/company/list",
      component: CompanyList,
      menuName: "settings",
      permission: "",
    },
    {
      path: "/:companySlug/booking/add-booking",
      component: AddBooking,
      menuName: "booking",
      permission: "bookings:create",
    },
    {
      path: "/:companySlug/booking/edit-booking/:booking_id",
      component: AddBooking,
      menuName: "booking",
      permission: "bookings:update",
    },
    {
      path: "/:companySlug/booking/add-delivery-booking",
      component: AddDeliveryBooking,
      menuName: "booking",
      permission: "bookings:create",
    },
    {
      path: "/:companySlug/booking/edit-delivery-booking/:booking_id",
      component: AddDeliveryBooking,
      menuName: "booking",
      permission: "bookings:update",
    },
    {
      path: "/:companySlug/booking/list",
      component: BookingList,
      menuName: "booking",
      permission: "bookings:list",
    },
    {
      path: "/:companySlug/booking/enquery/:bookingId",
      component: BookingEnquery,
      menuName: "booking",
      permission: "bookings:list",
    },
    {
      path: "/:companySlug/booking/assign-drivers",
      component: AssignDriver,
      menuName: "booking",
      permission: "bookings:assign-driver",
    },
    {
      path: "/:companySlug/booking/driver-jobs",
      component: DriverJobs,
      menuName: "booking",
      permission: "bookings:driver-jobs",
    },
    {
      path: "/:companySlug/booking/picked-items",
      component: PickedBooking,
      menuName: "booking",
      permission: "bookings:picked-items",
    },
    {
      path: "/:companySlug/shipping/container-list",
      component: ContainerList,
      menuName: "shipping",
      permission: "shipping:container-list",
    },
    {
      path: "/:companySlug/shipping/list",
      component: ShippingList,
      menuName: "shipping",
      permission: "shipping:list",
    },
    {
      path: "/:companySlug/shipping/add",
      component: AddShipping,
      menuName: "shipping",
      permission: "shipping:add",
    },
    {
      path: "/:companySlug/shipping/view/:shippingId",
      component: AddShipping,
      menuName: "shipping",
      permission: "shipping:update",
    },
    {
      path: "/:companySlug/delivery/receive-shipping",
      component: DeliveryReceiveShipping,
      menuName: "delivery",
      permission: "delivery:receive-shipping",
    },
    {
      path: "/:companySlug/delivery/assign-to-driver",
      component: DeliveryAssignTodriver,
      menuName: "delivery",
      permission: "delivery:assign-driver",
    },
    {
      path: "/:companySlug/delivery/driver-jobs",
      component: DriverJobDelivery,
      menuName: "delivery",
      permission: "delivery:driver-jobs",
    },
    {
      path: "/:companySlug/subscription/list",
      component: SubscriptionList,
      menuName: "subscription",
      permission: "subscription:read",
    },
    {
      path: "/:companySlug/membership/list",
      component: MembershipList,
      menuName: "membership",
      permission: "settings:membership-list",
    },
  ],
};
export const FrontRouteList = [HomeRoutes, ContactUsRoutes, TermsRoutes, TrackBookingRoutes];

export const DriverRoutes = {
  routeList: [
    {
      path: "/today-request-list",
      component: TodayRequestList,
    },
    {
      path: "/address-details/:id",
      component: DriverAddressDetails,
    },
    {
      path: "/address-edit/:id",
      component: DriverAddressEdit,
    },
    {
      path: "/item-details/:id",
      component: DriverItemDetails,
    },
    {
      path: "/item-edit/:id",
      component: DriverItemEdit,
    },
    {
      path: "/payment-details/:id",
      component: DriverPaymentDetails,
    },
  ],
};
export const CustomerRoutes = {
  routeList: [
    {
      path: "/my-bookings",
      component: MyBooking,
    },
    {
      path: "/add-booking",
      component: CustomerBooking,
    },
    {
      path: "/profile",
      component: CustomerMyProfile,
    },
    {
      path: "/update-profile",
      component: UpdateProfile,
    },
    {
      path: "/change-password",
      component: ChangePassword,
    },
    {
      path: "/track-booking",
      component: TrackBookingCustomer,
    },
    {
      path: "/referral-histories",
      component: ReferralHistory,
    },
  ],
};

export const WithoutThemeRouteList = [
  LoginRoutes,
  ForgotpasswordRoutes,
  ForgotpassworCodeCheckdRoutes,
  ForgotpasswordChangeRoutes,
  SignupRoutes,
  CustomerSignupRoutes,
  CustomerSignup2Routes
];